module.exports = __webpack_public_path__ + "img/wild.a25fdbf3.png";